module.exports = __webpack_public_path__ + "static/img/icon_snb_remp_svc.2007d21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_remp_svc.svg
// module id = 2EKI
// module chunks = 10